<template>
	<div v-if="airarsdlrlShow1">
		<div class="fadein_bind RARSDLRL">
			<div class="box" style="width: 840px;">
				<div class="head">
					<p>{{$t('aipf')}}</p>
					<img src="@/assets/images/close_03.png" @click="back" class="close" />
				</div>
				<div class="airank">
					<div class="item">
						<p>{{$t('bencily')}}</p>
						<audio :src="aiData.audioUrl" controls="controls"></audio>
					</div>
					<div class="item">
						<p>{{$t('bencipf')}}</p>
						<div class="total">
							<div class="icons">
								<div class="find">
									<p>{{aiData.score}}</p>
									<span>Total</span>
								</div>
							</div>
							<div class="frs">
								<div class="jds">
									<div class="icon">
										<span>{{$t('liulidu')}} </span>
										<img src="@/assets/images/whs_03.png" @click="showFluency()" />
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.chivoxScoreInfo.fluency/aiData.chivoxScoreInfo.fluencyTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.chivoxScoreInfo.fluency}}<i>/{{aiData.chivoxScoreInfo.fluencyTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('neirong')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showContent()" />
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.chivoxScoreInfo.content/aiData.chivoxScoreInfo.contentTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.chivoxScoreInfo.content}}<i>/{{aiData.chivoxScoreInfo.contentTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('fayin')}}</span>
										<img src="@/assets/images/whs_03.png"  @click="showPron()"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.chivoxScoreInfo.pronunciation/aiData.chivoxScoreInfo.pronunciationTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.chivoxScoreInfo.pronunciation}}<i>/{{aiData.chivoxScoreInfo.pronunciationTotal}}</i></em></span>
								</div>
							</div>
						</div>
					</div>
					<!--<div class="item">
						<p>口语能力分析</p>
						<div class="kyfx">
							<div class="lab">
								<div class="jds">
									<div class="icon">
										<span>发音准确性</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<span><em>{{aiData1.result.pron}}</em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>流畅度</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<span><em>{{aiData1.result.fluency.overall}}</em></span>
								</div>
							</div>
							<div class="lab">
								<div class="jds">
									<div class="icon">
										<span>停顿次数</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<span><em>{{aiData1.result.fluency.pause}}</em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>语速</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<span><em>{{aiData1.result.fluency.speed}}</em></span>
								</div>
							</div>
						</div>
					</div>-->
					<div class="item">
						<div class="h">
							<p>{{$t('fayininfo')}} <span style="color:red;font-weight: bold;" v-if="aiData.chivoxScoreInfo.speed&&aiData.chivoxScoreInfo.speed<=128">{{$t('speedtoslow')}}&nbsp;{{ aiData.chivoxScoreInfo.speed }}/min</span> <span style="color:red;font-weight: bold;" v-if="aiData.chivoxScoreInfo.speed&&aiData.chivoxScoreInfo.speed>=256">{{$t('speedtofast')}}&nbsp;{{ aiData.chivoxScoreInfo.speed }}/min</span></p>
							<ul>
								<li>
									<div></div>
									<span>{{$t('status1')}}</span>
								</li>
								<li>
									<div></div>
									<span>{{$t('status2')}}</span>
								</li>
								<li>
									<div></div>
									<span>{{$t('status3')}}</span>
								</li>
								<li>
									<div></div>
									<span>{{$t('status4')}}</span>
								</li>
							</ul>
						</div>
						<div class="contents" v-html="arrHtml"></div>
					</div>
					<div class="item" v-if="aiData.feedbackTeacherId">
						<div class="h">
							<p>{{$t('teacherfeedback')}}</p>
						</div>
						<div class="contents">
							<div v-if="aiData.feedbackAudio">
								<audio :src="aiData.feedbackAudio" style="width: 100%;" controls="controls"></audio>
							</div>
							<div v-if="aiData.feedbackText">
								<div v-html="aiData.feedbackText"></div>
							</div>
						</div>
					</div>
					<div class="button" style="margin-top: 28px;">
						<div class="on" @click="back">{{$t('back')}}</div>
						<div @click="back">{{$t('queding')}}</div>
					</div>
				</div>
			</div>
		</div>
		<AiDesc :descFont="descFont"></AiDesc>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'airarsdlrlShow1',
		props: ['aiData','aiData1'],
		data() {
			return {
				arrHtml: '',
				showbox: true,
				descFont: {}
			}
		},
		watch: {
			aiData(newValue, oldValue) {
				console.log(181, newValue)
				let arrHtml = ''
				if(newValue.chivoxScoreInfo&&newValue.chivoxScoreInfo.align) {
					newValue.chivoxScoreInfo.align.forEach((item) => {
						if(item.score >= 60 && item.score < 80) {
							arrHtml += `<span style="color: #8377f4">${item.txt}</span> `
						}
						else if(item.score >= 40 && item.score < 60) {
							arrHtml += `<span style="color: #fead4b">${item.txt}</span> `
						}
						else if(item.score < 40) {
							arrHtml += `<span style="color: #e60053">${item.txt}</span> `
						} else {
							arrHtml += `<span>${item.txt}</span> `
						}
					})
				}
				this.arrHtml = arrHtml
			},
		},
		mounted() {

		},
		computed: {
			airarsdlrlShow1() {
				return this.$store.state.airarsdlrlShow1;
			}
		},
		methods: {
			s() {
				console.log(this.aiData)
			},
			back() {
				this.$store.commit("showairarsdlrlShow1", false);
			},
			showFluency(){
				this.descFont = {
					title: this.$i18n.t('liulidu'),
					desc: this.$i18n.t('liulidudesc')
				}
				this.$store.commit("showaiDESCShow", true);
			},
			showContent(){
				this.descFont = {
					title: this.$i18n.t('neirong'),
					desc: this.$i18n.t('neirongdesc')
				}
				this.$store.commit("showaiDESCShow", true);
			},
			showPron(){
				this.descFont = {
					title: this.$i18n.t('fayin'),
					desc: this.$i18n.t('fayindesc')
				}
				this.$store.commit("showaiDESCShow", true);
			},
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ai-DLRL.vue